import Popover from "@mui/material/Popover";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ccAttribute from "../_helper/ccAttribute";
import React, {Fragment, useEffect, useState} from "react";
import {IDataTalentSkill} from "../_interfaces/IDataTalentSkill";
import {InfoTalentSkillSubscriber} from "../_helper/InfoTalentSkillBehave";
import skill_improvise from "../_data/skill_improvise";

function TalentSkillPopover() {

    const [infoTalentSkill, setInfoTalentSkill] = useState<IDataTalentSkill|null>(null);
    const [infoTalentSkillAncor, setInfoTalentSkillAncor] = useState<Element | null>(null);
    const [infoTalentSkillOpen, setInfoTalentSkillOpen] = useState(false);

    useEffect(() => {
        const subscription = InfoTalentSkillSubscriber.subscribe((newValue) => {
            setInfoTalentSkill(newValue.pop);
            setInfoTalentSkillAncor(newValue.popEl)
            setInfoTalentSkillOpen(newValue.popOpen)
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const handleClose=()=>{
        setInfoTalentSkillAncor(null)
        setInfoTalentSkill(null)
        setInfoTalentSkillOpen(false);
    }

    if (infoTalentSkillOpen&&infoTalentSkill) return <Popover
        open={infoTalentSkillOpen}
        anchorEl={infoTalentSkillAncor}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
    >
        <Grid container spacing={1} style={{padding: 10}}>
            <Grid item xs={10}>
                {infoTalentSkill?.name}
            </Grid>
            <Grid item xs={2}>
                <Button onClick={()=>handleClose()}>X</Button>
            </Grid>
            <Grid item xs={12}>
                <div>
                    Beschreibung:
                    {infoTalentSkill?.desc}
                </div>
                {infoTalentSkill?.as_skill ? <div>
                    Als Fertigkeit:
                    {infoTalentSkill.as_skill}
                </div> : null}
            </Grid>
            <Grid item xs={10}>
                Attribut: {ccAttribute(infoTalentSkill.attribute, 'tt')}
            </Grid>
            <Grid item xs={10}>
                Aktion: {infoTalentSkill.action}
            </Grid>
            {infoTalentSkill.lps_skill ? <Grid item xs={10}>
                Startkosten: {infoTalentSkill.lps_skill}
            </Grid> : null}
            {infoTalentSkill.lps_skill && infoTalentSkill.strain_skill ? <Grid item xs={10}>
                Überanstrengung: {infoTalentSkill.strain_skill}
            </Grid> : null}
            {infoTalentSkill.talent && infoTalentSkill.strain ? <Grid item xs={10}>
                Überanstrengung: {infoTalentSkill.strain}
            </Grid> : null}
            {infoTalentSkill.lps_skill && skill_improvise.includes(infoTalentSkill.name) ? <Grid item xs={10}>
                impovisierbar (nur mit attribut)
            </Grid> : null}
        </Grid>
    </Popover>

    return <Fragment/>

}

export default TalentSkillPopover;